<script>
import GlyphSetPreview from "@/components/GlyphSetPreview";

export default {
  name: "GlyphSetRecordsTab",
  components: {
    GlyphSetPreview
  },
  data() {
    return {
      recordGlyphInfo: [],
    };
  },
  methods: {
    update() {
      const bestReality = player.records.bestReality;
      const laitelaDim = 8 - Laitela.difficultyTier;
      this.recordGlyphInfo = [
        [true, Glyphs.copyForRecords(bestReality.RMSet), "Лучшие Машины Реальности",
          `${format(bestReality.RM, 2, 2)} МР`],
        [true, Glyphs.copyForRecords(bestReality.RMminSet), "Лучшие Машин Реальности в минуту",
          `${format(bestReality.RMmin, 2, 2)} МР/мин`],
        [true, Glyphs.copyForRecords(bestReality.glyphLevelSet), "Лучший уровень Глифа",
          `Уровень ${formatInt(bestReality.glyphLevel)}`],
        [true, Glyphs.copyForRecords(bestReality.bestEPSet), "Наибольшие Очки Вечности",
          `${format(bestReality.bestEP, 2, 2)} ОВ`],
        [true, Glyphs.copyForRecords(bestReality.speedSet), "Самая быстрая Реальность (реальное время)",
          `${TimeSpan.fromMilliseconds(bestReality.realTime).toStringShort()}`],
        [player.celestials.teresa.bestRunAM.gt(1), Glyphs.copyForRecords(player.celestials.teresa.bestAMSet),
          `Наибольшая Антиматерия в Реальности ${Teresa.possessiveName}`,
          `${format(player.celestials.teresa.bestRunAM, 2, 2)} Антиматерии`],
        [Currency.imaginaryMachines.gt(0), Glyphs.copyForRecords(bestReality.iMCapSet),
          "Наибольшее Ограничение Мнимых Машин",
          `${format(MachineHandler.currentIMCap, 2, 2)} ММ`],
        [Laitela.isUnlocked, Glyphs.copyForRecords(bestReality.laitelaSet),
          `Лучшая Дестабилизация ${Laitela.displayName}`,
          `${TimeSpan.fromSeconds(player.celestials.laitela.fastestCompletion).toStringShort()},
           ${ruQuantifyInt("Измерение,Измерения,Измерений",
    laitelaDim)} (${formatX(Laitela.realityReward, 2, 2)} ТМ)`],
      ];
    },
  }
};
</script>

<template>
  <div class="l-glyph-set-tab">
    <div
      v-for="(set, idx) in recordGlyphInfo"
      :key="idx"
    >
      <div
        v-if="set[0]"
        class="l-glyph-set-entry"
      >
        {{ set[2] }}:
        <GlyphSetPreview
          v-if="set[0]"
          :key="idx"
          :glyphs="set[1]"
          :text="set[2]"
          :text-hidden="true"
        />
        {{ set[3] }}
        <br>
      </div>
    </div>
  </div>
</template>
